import { Component } from '@angular/core';

@Component({
  selector: 'app-redirect-survey-component',
  template: `<p>Redirecting...</p>`
})

export class RedirectSurveyComponent {}